import Index from "views/Index.js";
import Login from "views/examples/Login.js";
import Tokens from "views/examples/Tokens.js";
import Plans from "views/examples/Plans.js";
import Referrals from "views/examples/Referrals.js";
import Withdraw from "views/examples/Withdraw";

var routes = [
    {
        path: "/index",
        name: "Dashboard",
        icon: "ni ni-tv-2 text-primary",
        component: <Index />,
        layout: "/admin",
    },
    {
        path: "/tokens",
        name: "Tokens",
        icon: "ni ni-money-coins text-green",
        component: <Tokens />,
        layout: "/admin",
    },
    {
        path: "/plans",
        name: "Plans",
        icon: "ni ni-chart-pie-35 text-purple",
        component: <Plans />,
        layout: "/admin",
    },
    {
        path: "/withdrawRequests",
        name: "Withdrawls",
        icon: "ni ni-credit-card text-yellow",
        component: <Withdraw />,
        layout: "/admin",
    },
    {
        path: "/referrals",
        name: "Referrals",
        icon: "ni ni-circle-08 text-pink",
        component: <Referrals />,
        layout: "/admin",
    },
    {
        path: "/login",
        // name: "Login",
        // icon: "ni ni-key-25 text-info",
        component: <Login />,
        layout: "/auth",
    },
];
export default routes;
